import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Icon, notification } from "antd";
import axios from "axios";
import moment from "moment";

import ExcelTabelaFrequencia from "../../_Aux/ExcelTabelaFrequencia";
import CardsFrequencia from "../../_Aux/CardsFrequencia";
import ModalViewer from "../../../../shared/components/Modals/ModalViewer";
import ModalHorariosFrequencias from "../../_Aux/ModalHorariosFrequencias";
import ModalLoading from "../../../../shared/components/Modals/ModalLoading";
import ModalGerarDocumento from "../../../../shared/components/Modals/GerarDocumento";
import ModalAta from "../../../Aproveitamento/Relatorios/Drawer/Ata";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message,
        description
    });
};

function ListaFrequencia(props) {
    const [disciplinaId, setDisciplinaId] = useState(
        localStorage.getItem("vista") === "TURMA" ? null : localStorage.getItem("codigo_curso")
    );

    const entidadeId = localStorage.getItem("entidade_id");

    // EXPORTAR
    const [visibleExportar, setVisibleExportar] = useState(false);
    const [btnDescarregar, setBtnDescarregar] = useState(false);
    const [ficheiroExportar, setFicheiroExportar] = useState("");
    const [fichaExcel, setFichaExcel] = useState(false);

    // LOADING
    const [visibleLoading, setVisibleLoading] = useState(false);

    // VIEWER
    const [visibleViewer, setVisibleViewer] = useState(false);
    const [docs, setDocs] = useState([]);

    // DATAS
    const [dates, setDates] = useState([]);

    const [isModalVisible, setIsModalVisible] = useState(false);

    useEffect(() => {
        setDisciplinaId(localStorage.getItem("vista") === "TURMA" ? null : localStorage.getItem("codigo_curso"));
    }, [props.location.pathname]);

    const exportar = () => {
        setVisibleExportar(true);
        setBtnDescarregar(true);

        axios({
            method: "get",
            url: "/api/excel/faltas-horas",
            params: {
                cursoId: disciplinaId
            }
        })
            .then(response => {
                setBtnDescarregar(false);
                setFicheiroExportar(response.data);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");
                setVisibleExportar(false);
            });
    };

    const getMeses = () => {
        axios({
            method: "get",
            url: "/api/aulas-exportar/get-meses-frequencias",
            params: {
                id: disciplinaId == null ? localStorage.getItem("codigo_curso") : disciplinaId
            }
        })
            .then(response => {
                setDates(response.data);
            })
            .catch(() => {});
    };

    const exportarPdf = (disciplina, option, startDate, endDate, dataEmissao) => {
        getMeses();
        setVisibleLoading(true);

        axios({
            method: "get",
            url: "/api/pdf/frequencia-pdf",
            params: {
                cursoId: disciplina,
                start: moment(startDate).format("YYYY/MM/DD"),
                end: moment(endDate).format("YYYY/MM/DD"),
                tipo: option,
                dataEmissao: moment(dataEmissao).format("YYYY/MM/DD")
            }
        })
            .then(response => {
                const { url, fileName } = response.data;

                setVisibleLoading(false);
                setVisibleViewer(true);
                setDocs([{ uri: url, fileName }]);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");
                setVisibleLoading(false);
            });
    };

    const ExportarExcel = dataEmissao => {
        setVisibleExportar(true);
        setBtnDescarregar(true);
        axios({
            method: "get",
            url: "/api/excel/excel-ouro-branco",
            params: {
                cursoId: localStorage.getItem("codigo_curso"),
                dataEmissao: moment(dataEmissao).format("DD/MM/YYYY")
            }
        })
            .then(response => {
                setBtnDescarregar(false);
                setFicheiroExportar(response.data.url);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível exportar documento!");

                setVisibleExportar(false);
            });
    };

    const toggleModal = () => {
        getMeses();
        setIsModalVisible(prev => !prev);
    };

    return (
        <>
            <div className="container container-body">
                <div className="bloco-curso-diario-opcoes" style={{ gap: 10 }}>
                    <h3 className="titulo-bloco">Frequência</h3>
                    <div className="bloco-opcoes-esquerda">
                        <Link className={`botao-icon-detalhe botao-maior`} to="#" title="Descarregar" onClick={toggleModal}>
                            <Icon type="eye" />
                        </Link>

                        {entidadeId === "37" && localStorage.getItem("vista") === "TURMA" ? (
                            <>
                                {!disciplinaId ? (
                                    <Link
                                        className={`botao-icon-excel botao-maior`}
                                        to="#"
                                        title="Descarregar"
                                        onClick={() => setFichaExcel(true)}
                                    >
                                        <Icon type="download" />
                                    </Link>
                                ) : (
                                    <Link
                                        className={`botao-icon-download botao-maior ${!disciplinaId ? "botao-disabled" : ""}`}
                                        to="#"
                                        title="Descarregar"
                                        disabled={!disciplinaId}
                                        style={{ margin: 0 }}
                                        onClick={exportar}
                                    >
                                        <Icon type="download" />
                                    </Link>
                                )}
                            </>
                        ) : (
                            <Link
                                className={`botao-icon-download botao-maior ${
                                    localStorage.getItem("vista") === "TURMA" && !disciplinaId ? "botao-disabled" : ""
                                }`}
                                to="#"
                                title="Descarregar"
                                disabled={localStorage.getItem("vista") === "TURMA" && !disciplinaId}
                                style={{ margin: 0 }}
                                onClick={exportar}
                            >
                                <Icon type="download" />
                            </Link>
                        )}

                        <Link
                            to={`/gerir-multisseriado/${props.match.params.turma}/${
                                localStorage.getItem("vista") === "TURMA" ? "horario" : "horario-disciplina"
                            }`}
                            className="botao-secundario botao-secundario-redondo"
                            title="Voltar"
                            style={{
                                marginRight: 10,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                        >
                            <Icon type="arrow-left" />
                        </Link>
                    </div>
                </div>

                <div className="curso-diario curso-diario-frequencia-desktop">
                    <ExcelTabelaFrequencia setDisciplinaId={id => setDisciplinaId(id)} />
                </div>

                <div className="curso-diario curso-diario-frequencia-mobile">
                    <CardsFrequencia setDisciplinaId={id => setDisciplinaId(id)} />
                </div>
            </div>

            <ModalGerarDocumento
                visibleExportar={visibleExportar}
                ficheiroExportar={ficheiroExportar}
                btnDescarregar={btnDescarregar}
                onClose={() => setVisibleExportar(false)}
            />

            <ModalLoading visible={visibleLoading} text="A gerar documento..." />

            <ModalViewer visible={visibleViewer} docs={docs} onCancel={() => setVisibleViewer(false)} />

            <ModalHorariosFrequencias
                datas={dates}
                disciplina={disciplinaId}
                visible={isModalVisible}
                onClose={toggleModal}
                onSelect={(option3, option1, option2, dataEmissao) => {
                    exportarPdf(option3, option1, option2.start_date, option2.end_date, dataEmissao);
                }}
            />

            <ModalAta
                visible={fichaExcel}
                onClose={() => setFichaExcel(false)}
                onConfirm={dataEmissao => {
                    ExportarExcel(dataEmissao);
                    setFichaExcel(false);
                }}
            />
        </>
    );
}

export default ListaFrequencia;
